import { render, staticRenderFns } from "./SocialsIcons.vue?vue&type=template&id=eb06a126&scoped=true&"
import script from "./SocialsIcons.vue?vue&type=script&lang=js&"
export * from "./SocialsIcons.vue?vue&type=script&lang=js&"
import style0 from "./SocialsIcons.vue?vue&type=style&index=0&id=eb06a126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb06a126",
  null
  
)

export default component.exports